import { getMultipleProductCount } from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import { useTranslations } from 'next-intl';

export const ProductBundle = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');

  if (!product) {
    return null;
  }

  const multipleProductCount = getMultipleProductCount(product.tags!);

  if (!multipleProductCount || multipleProductCount < 2) {
    return null;
  }

  return (
    <p className="tw-grid-area-[bundle]">
      <span className="tw-lf-tag tw-lf-tag-accent tw-lf-tag-sm">
        {tCatalog('productMultiple', {
          number: multipleProductCount,
        })}{' '}
      </span>
    </p>
  );
};
